import { render, staticRenderFns } from "./ExamProfilesDetail.vue?vue&type=template&id=32259fe4"
import script from "./ExamProfilesDetail.vue?vue&type=script&lang=js"
export * from "./ExamProfilesDetail.vue?vue&type=script&lang=js"
import style0 from "./ExamProfilesDetail.vue?vue&type=style&index=0&id=32259fe4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports